export const GET = 'ta/data/GET'
export const REMOVE = 'ta/data/REMOVE'
export const ADD_TEAM = 'ta/data/ADD_TEAM'
export const ADD_NOTIFICATION = 'ta/data/ADD_NOTIFICATION'
